(function ($, app) {
    if (!$) {
        return;
    }

    const $modal = $('#commonModal');
    const $title = $('#commonModalTitle');
    const $body = $modal.find('.modal__body');

    app.modal = {
        open(options) {
            $title.text(options.title || 'Modal');
            $modal.addClass('is-open').attr('aria-hidden', 'false');
            $body.html('<div class="panel">Loading...</div>');

            app.ajax.request({
                url: options.url,
                method: 'GET',
                dataType: 'html',
            }).done((html) => {
                $body.html(html);
                app.core.enhance($body);
            });
        },

        close() {
            $modal.removeClass('is-open').attr('aria-hidden', 'true');
            $body.empty();
        },
    };

    $(document).on('click', '.js-open-modal', function () {
        app.modal.open({
            url: $(this).data('url'),
            title: $(this).data('title'),
        });
    });

    $(document).on('click', '.js-modal-close', function () {
        app.modal.close();
    });
})(window.jQuery, window.ITConnect);
